import React from 'react';

const BasePage = props =>(
    <div className="wrapper app-background">
        { props.children }
    </div>
)

export default BasePage;
